import { render } from "./formList.vue?vue&type=template&id=3e135f6c&scoped=true&ts=true"
import script from "./formList.vue?vue&type=script&lang=ts"
export * from "./formList.vue?vue&type=script&lang=ts"

import "./formList.vue?vue&type=style&index=0&id=3e135f6c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e135f6c"]])

export default __exports__